var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useEffect, useRef } from 'react';
import { Card } from '@amzn/atoz-web/Card';
import { Text } from '@amzn/atoz-web/Text';
import { Col } from '@amzn/atoz-web/Col';
import { View } from '@amzn/atoz-web/View';
import { styledWithTheme } from '@amzn/atoz-web/Theme';
import { useBreakpoints } from '@amzn/atoz-web/Responsive';
import { DateTime } from 'luxon';
import { useTranslation } from 'react-i18next';
export function getDateText(date, isLargerViewPort) {
    // TODO: look into why Apollo is shallow copying data
    // have to create a new date since Apollo seems to be shallow copying objects so weekData is being set to null
    var dateWithWeekInfo = DateTime.fromISO(date.toISO());
    return isLargerViewPort ? (React.createElement(React.Fragment, null,
        React.createElement(Text, { textAlign: "center", fontSize: "T200" }, dateWithWeekInfo.weekdayLong),
        React.createElement(Text, { textAlign: "center", fontSize: "T200" },
            dateWithWeekInfo.monthShort,
            " ",
            dateWithWeekInfo.day))) : (React.createElement(Text, { textAlign: "center", fontSize: "T100" }, "".concat(dateWithWeekInfo.weekdayShort, " ").concat(dateWithWeekInfo.monthShort, " ").concat(dateWithWeekInfo.day)));
}
var cardWidthPropsMap = {
    s: { width: 80, height: 25, padding: 5 },
    m: { width: 80, height: 25, padding: 5 },
    l: { width: 110, height: 45 },
    xl: { width: 110, height: 45 }
};
export var DayCard = function (_a) {
    var date = _a.date, selected = _a.selected, setSelectedDay = _a.setSelectedDay, numberOfShifts = _a.numberOfShifts, isLargerViewport = _a.isLargerViewport;
    var cardWidthProps = useBreakpoints({
        propsMap: cardWidthPropsMap
    }).props;
    var cardRef = useRef(null);
    var t = useTranslation().t;
    useEffect(function () {
        var _a;
        if (selected) {
            (_a = cardRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({
                behavior: 'smooth',
                inline: 'nearest',
                block: 'nearest'
            });
        }
    }, []);
    function handleFocus(event) {
        event.target.scrollIntoView({
            behavior: 'smooth',
            inline: 'nearest',
            block: 'nearest'
        });
    }
    function handleKeyboard(event) {
        if (event.key === 'Enter' || event.key === 'Space') {
            setSelectedDay(date);
        }
    }
    var dateWithWeekInfo = DateTime.fromISO(date.toISO());
    var ariaLabel = t('shift_management_features_DaySelector_DayCard_ariaLabel', {
        weekday: dateWithWeekInfo.weekdayLong,
        month: dateWithWeekInfo.monthShort,
        day: dateWithWeekInfo.day,
        number: numberOfShifts
    }) +
        (selected
            ? t('shift_management_features_DaySelector_DayCard_ariaLabel_selected')
            : '');
    return (React.createElement(StyledCard, { justifyContent: "center", tabIndex: 0, onFocus: handleFocus, isSelected: selected, onClick: function () { return setSelectedDay(date); }, onKeyPress: handleKeyboard, dataTestId: "day-card", ref: cardRef, role: "tab", "aria-label": ariaLabel },
        React.createElement(Col, __assign({ color: selected ? 'neutral0' : 'neutral100', justifyContent: "center" }, cardWidthProps), getDateText(date, isLargerViewport)),
        numberOfShifts > 0 && (React.createElement(NumberOfShiftsIndicator, { dataTestId: "number-of-shifts" }, numberOfShifts))));
};
var StyledCard = styledWithTheme(Card)(function (_a) {
    var selectors = _a.theme.selectors, isSelected = _a.isSelected;
    return "\n    cursor: pointer;\n    border: 2px solid ".concat(selectors.color('neutral70'), ";\n    background-color: ").concat(isSelected ? selectors.color('neutral100') : selectors.color('neutral0'), ";\n    color: ").concat(isSelected ? selectors.color('neutral0') : selectors.color('neutral100'), ";\n    padding: ").concat(selectors.space('S100'), "px;\n");
});
var NumberOfShiftsIndicator = styledWithTheme(View)(function (_a) {
    var theme = _a.theme;
    return "\n    position: absolute;\n    top: -7px;\n    right: -7px;\n    height: 20px;\n    width: 20px;\n    background: ".concat(theme.selectors.color('primary70'), ";\n    color: ").concat(theme.selectors.color('neutral0'), ";\n    font-size: ").concat(theme.selectors.fontSize('T100'), ";\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 50%;\n");
});
